
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.5 11L2 18.5h4.5a1 1 0 011 1v4m-5.5-5l-.5 5m22-12.5L22 18.5h-4.5a1 1 0 00-1 1v4m5.5-5l.5 5M12 6.5v17m-6.5-9h13m3.682-8.966A88.601 88.601 0 0112 .5 88.61 88.61 0 011.818 5.534.5.5 0 002 6.5h20a.5.5 0 00.182-.966v0z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    